/* eslint-disable no-unused-vars */
import Vue from 'vue'
import { firestoreAction } from 'vuexfire'
import GameService from '@/services/GameService.js'
import { db, firebaseApp, realtimeDB } from '../db'

export const namespaced = true

export const state = {
  game: {},
  teamData: {},
  teams: [],
  loading: true,
  gameError: undefined,
  teamDataError: undefined,
  teamListError: undefined,
  playerName: undefined,
  clockOffset: undefined
}
export const mutations = {
  SET_GAME(state, game) {
    state.game = game
  },
  SET_CLOCK_OFFSET(state, offset) {
    state.clockOffset = offset
  },
  SET_GAME_ERROR(state, error) {
    state.gameError = error
  },
  SET_TEAM_DATA_ERROR(state, error) {
    state.teamDataError = error
  },
  SET_TEAM_LIST_ERROR(state, error) {
    state.teamListError = error
  },
  SET_ANSWER(state, { challengeIndex, questionIndex, answer }) {
    Vue.set(
      state.teamData.gameData.challenges[challengeIndex].questions[
        questionIndex
      ],
      'answer',
      answer
    )
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  }
}
export const actions = {
  fetchClockOffset({ commit }, params) {
    return new Promise((resolve, reject) => {
      console.log(`firebase: ${realtimeDB}`)

      realtimeDB.ref('.info/serverTimeOffset').on(
        'value',
        snapshot => {
          const serverTimeOffset = snapshot.val()

          commit('SET_CLOCK_OFFSET', serverTimeOffset)
          resolve()
        },
        function(err) {
          console.log(`error getting server time offset: ${err}`)
        }
      )
    })
  },
  fetchGame({ commit }, params) {
    return new Promise((resolve, reject) => {
      GameService.getGame(params.code)
        .then(response => {
          commit('SET_GAME', response.data.data)
          commit('SET_LOADING', false)

          resolve(response)
        })
        .catch(error => {
          commit('SET_LOADING', false)
          console.log(
            'There was a problem fetching game data: ' + error.message
          )

          reject(error)
        })
    })
  },
  fetchTeams: firestoreAction(({ commit, bindFirestoreRef }, params) => {
    bindFirestoreRef(
      'teams',
      db
        .collection(`gameCodes/${params.code.toUpperCase()}/teams`)
        .orderBy('points', 'desc')
        .orderBy('teamName', 'asc')
    )
      .then(teams => {
        if (!teams) {
          console.log(`👷‍♂️ GameStore: Game Teams List not found`)
          commit('SET_TEAM_LIST_ERROR', { message: 'Teams list not found' })
        } else {
          commit('SET_TEAM_LIST_ERROR', undefined)
        }
      })
      .catch(err => {
        console.log(`👁👁 GameStore: Error while fetching teams list: ${err}`)

        commit('SET_TEAM_LIST_ERROR', {
          message: `Error fetching data: ${err}`
        })
      })
  }),
  unbindTeamData: firestoreAction(({ unbindFirestoreRef }) => {
    unbindFirestoreRef('teamData')
  }),
  fetchTeamData: firestoreAction(({ commit, bindFirestoreRef }, params) => {
    bindFirestoreRef(
      'teamData',
      db
        .collection(`gameCodes/${params.code.toUpperCase()}/teamData`)
        .doc(params.teamId)
    )
      .then(doc => {
        if (!doc) {
          console.log(`👷‍♂️ GameStore: Team Data not found`)
          commit('SET_TEAM_DATA_ERROR', { message: 'Team not found' })
        } else {
          console.log(`🫀 GameStore: Fetched team game data: ${doc}`)

          commit('SET_TEAM_DATA_ERROR', undefined)
        }
      })
      .catch(err => {
        console.log(`👁👁 GameStore: Error while fetching team game data: ${err}`)

        commit('SET_TEAM_DATA_ERROR', {
          message: `Error fetching data: ${err}`
        })
      })
  }),
  createGame({ commit }, params) {
    return new Promise((resolve, reject) => {
      GameService.createTeam(params.code, params.teamName)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log('There was a problem creating a team: ' + error.message)

          reject(error)
        })
    })
  },
  requestHint({ commit }, params) {
    return new Promise((resolve, reject) => {
      GameService.requestHintForQuestion(
        params.code,
        params.teamId,
        params.challengeIndex,
        params.questionIndex
      )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log('There was a problem requestion a hint: ' + error.message)

          reject(error)
        })
    })
  },

  addMemberToTeam({ commit }, params) {
    return new Promise((resolve, reject) => {
      GameService.addMemberToTeam(
        params.code,
        params.teamId,
        params.teamMemberName
      )
        .then(response => {
          this.playerName = params.teamMemberName

          resolve(response)
        })
        .catch(error => {
          console.log(
            'There was a problem adding a member to the team: ' + error.message
          )

          reject(error)
        })
    })
  },
  updateProposedChallenge({ commit }, params) {
    return new Promise((resolve, reject) => {
      GameService.updateProposedChallenge(
        params.code,
        params.teamId,
        params.challengeIndex,
        this.playerName
      )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(
            'There was a problem updating the proposed challenge index: ' +
              error.message
          )

          reject(error)
        })
    })
  },
  updateCurrentChallenge({ commit }, params) {
    return new Promise((resolve, reject) => {
      GameService.updateCurrentChallenge(
        params.code,
        params.teamId,
        params.challengeIndex
      )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(
            'There was a problem updating the current challenge index: ' +
              error.message
          )

          reject(error)
        })
    })
  },
  updateCurrentQuestion({ commit }, params) {
    return new Promise((resolve, reject) => {
      GameService.updateCurrentQuestion(
        params.code,
        params.teamId,
        params.challengeIndex,
        params.questionIndex
      )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(
            'There was a problem updating the current question index: ' +
              error.message
          )

          reject(error)
        })
    })
  },
  answerQuestion({ commit }, params) {
    return new Promise((resolve, reject) => {
      GameService.answerQuestion(
        params.code,
        params.teamId,
        params.challengeIndex,
        params.questionIndex,
        params.data
      )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(
            'There was a problem answering the question: ' + error.message
          )

          reject(error)
        })
    })
  }
}
export const getters = {}
